<template>
  <div class="customer-list">
    <header-top></header-top>
    <div class="header-title">客源列表</div>
    <div class="customer-list-main">
      <div class="main-top">
        <el-input
          :placeholder="searchText"
          v-model="searchValue"
          class="input-with-select"
          clearable
        >
          <el-select
            v-model="search"
            slot="prepend"
            placeholder="客源姓名"
            @change="filterSelect"
          >
            <el-option
              v-for="item in searchOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="searchCustomers"
          ></el-button>
        </el-input>
      </div>
      <div class="main-filter">
        <div class="filter-item">
          <span class="filter-lable">位置:</span>
          <span
            class="filter-lable"
            :class="{ 'is-selected': item.data.isSelected }"
            v-for="(item, index) in filterData.position"
            @click="
              selectItem(
                filterData.position,
                item.data.name,
                item.data.name,
                '位置',
                'position',
                item.children
              )
            "
            :key="index"
            >{{ item.data.name }}</span
          >
        </div>
        <div
          class="filter-item filter-children-item"
          v-if="filterData.district.length > 0"
        >
          <span
            class="filter-lable"
            :class="{ 'is-selected': item.data.isSelected }"
            v-for="(item, index) in filterData.district"
            @click="
              selectItem(
                filterData.district,
                item.data.name,
                item.data.name,
                '区县',
                'district'
              )
            "
            :key="index"
            >{{ item.data.name }}</span
          >
        </div>
        <div class="filter-item">
          <span class="filter-lable">意图:</span>
          <span
            class="filter-lable"
            :class="{ 'is-selected': item.isSelected }"
            v-for="(item, index) in filterData.intention"
            @click="
              selectItem(
                filterData.intention,
                item.label,
                item.value,
                '意图',
                'intention'
              )
            "
            :key="index"
            >{{ item.label }}</span
          >
        </div>
        <div class="filter-item">
          <span class="filter-lable">价格:</span>
          <span
            class="filter-lable"
            :class="{ 'is-selected': item.isSelected }"
            v-for="(item, index) in filterData.price"
            :key="index"
            @click="
              selectItem(
                filterData.price,
                item.label,
                item.value,
                '价格',
                'price'
              )
            "
            >{{ item.label }}</span
          >
          <el-input
            v-model="price.min"
            placeholder="最低"
            type="number"
          ></el-input>
          <span class="input-line">-</span>
          <el-input
            v-model="price.max"
            placeholder="最高"
            type="number"
          ></el-input>
          <span class="input-unit">万</span>
          <el-button
            type="primary"
            size="mini"
            v-if="price.min && price.max"
            @click="
              selectItem(filterData.price, '自定义价格', price, '价格', 'price')
            "
            >确 定</el-button
          >
        </div>
        <div class="filter-item">
          <span class="filter-lable">居室:</span>
          <span
            class="filter-lable"
            :class="{ 'is-selected': item.isSelected }"
            v-for="(item, index) in filterData.houseType"
            @click="
              selectItem(
                filterData.houseType,
                item.label,
                item.value,
                '居室',
                'houseType'
              )
            "
            :key="index"
            >{{ item.label }}</span
          >
        </div>
        <div class="filter-item">
          <span class="filter-lable">等级:</span>
          <span
            class="filter-lable"
            :class="{ 'is-selected': item.isSelected }"
            v-for="(item, index) in filterData.followLevel"
            @click="
              selectItem(
                filterData.followLevel,
                item.label,
                item.value,
                '等级',
                'followLevel'
              )
            "
            :key="index"
            >{{ item.label }}</span
          >
        </div>
        <div class="filter-item filter-filter">
          <span class="filter-lable">筛选:</span>
          <div class="flex">
            <el-dropdown
              @command="dropdownClick"
              placement="bottom-start"
              :ref="item.name"
              v-for="(item, index) in filterData.filter"
              :key="index"
            >
              <span class="el-dropdown-link">
                {{ item.name }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="filter-dropdown">
                <el-dropdown-item
                  :command="
                    item.name +
                    ' ' +
                    el.name +
                    ' ' +
                    el.value +
                    ' ' +
                    item.label
                  "
                  v-for="(el, i) in item.children"
                  :key="i"
                  :class="{ 'dropdown-hover': el.hasOwnProperty('children') }"
                >
                  <div
                    class="dropdown-item"
                    v-if="el.hasOwnProperty('children')"
                  >
                    {{ el.name }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </div>
                  <el-date-picker
                    v-else-if="el.name == '自定义'"
                    v-model="filterDate"
                    @change="changeFilterDate(filterDate, item.name)"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                  ></el-date-picker>
                  <div
                    class="dropdown-items"
                    v-if="el.hasOwnProperty('children')"
                  >
                    <div
                      v-for="ele in el.children"
                      :key="ele"
                      class="dropdown-item"
                      @click.stop="dropdownChildClick(item.name + ' ' + ele)"
                    >
                      {{ ele }}
                    </div>
                  </div>
                  <span v-else>{{ el.name }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="main-condition" v-if="filterTags.length">
        <div class="condition-text">当前查找条件</div>
        <div class="tag-items">
          <el-tag
            v-for="tag in filterTags"
            :key="tag.name"
            size="medium"
            :disable-transitions="false"
            @close="handleTagClose(tag)"
            closable
            >{{ tag.name }}：{{ tag.label }}</el-tag
          >
          <div class="clear-btn" @click="clearTags">
            <i class="el-icon-delete"></i>清空条件
          </div>
        </div>
      </div>
      <div class="main-btns">
        <div>
          <el-button type="primary" @click="createCustomer" icon="el-icon-plus"
            >添加客源</el-button
          >
          <el-button
            :disabled="multipleSelection.length == 0"
            @click="deleteCustomers"
            >删除客源</el-button
          >
          <span class="table-top">
            共 {{ customers.length }} 条，已选
            <span class="selected-num">{{ multipleSelection.length }}</span> 条
          </span>
        </div>
      </div>
      <div class="main-table">
        <el-table
          :data="customers"
          ref="houseTable"
          stripe
          style="width: 100%"
          @selection-change="handleSelectionChange"
          @sort-change="changeSort"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="客户姓名" width="100">
            <template slot-scope="scope">
              <span
                class="customer-name"
                @click="goCustomerDetail(scope.row.id)"
                >{{ scope.row.name | nullValue }}</span
              >
              <span class="attention-level">{{
                scope.row.attentionLevel[0]
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="联系电话" prop="phoneNumber" width="120">
          </el-table-column>
          <el-table-column label="意图" prop="intention" width="70">
            <template slot-scope="scope">
              {{ scope.row.intention | nullValue }}
            </template>
          </el-table-column>
          <el-table-column label="需求">
            <template slot-scope="scope">
              <div v-if="scope.row.minTotalPrice&&scope.row.houseTypes.length">
                <span
                  >{{ scope.row.minTotalPrice }}-{{
                    scope.row.maxTotalPrice
                  }}万元
                </span>
                <span v-if="scope.row.houseTypes.length"
                  >，{{ scope.row.houseTypes.join("，") }}</span
                >
              </div>
              <div v-else>—</div>
            </template>
          </el-table-column>
          <el-table-column label="意向商圈">
            <template slot-scope="scope">
              <span>{{ scope.row.addresses | addressesFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column label="进度" width="70" prop="visitStatus">
          </el-table-column>
          <el-table-column label="归属人" width="80" prop="creatorName">
          </el-table-column>
          <el-table-column label="带看" width="60">
            <template slot-scope="scope">
              <span
                >{{ scope.row.visitCount ? scope.row.visitCount : 0 }}次</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="录入时间"
            sortable
            width="100"
            prop="creationTime"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.creationTime | dateFormatYMD }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="最后跟进"
            sortable
            width="100"
            prop="lastFollowTime"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.lastFollowTime | timeAgo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" fixed="right">
            <template slot-scope="scope">
              <div class="table-operation">
                <el-button
                  @click.native.prevent="goCustomerDetail(scope.row.id)"
                  type="text"
                  >管理</el-button
                >
                <el-button
                  @click.native.prevent="editCustomer(scope.row.id)"
                  type="text"
                  >编辑</el-button
                >
                <el-popover placement="bottom" trigger="click">
                  <el-button
                    @click.native.prevent="delCustomer(scope.row.id)"
                    type="text"
                    class="del-btn"
                    >删除</el-button
                  >
                  <el-button slot="reference" type="text" class="more-btn">更多</el-button>
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="loading-box" v-if="isLoading">
              <img
                src="@/assets/image/loading.png"
                alt="loading"
                class="loading-ico"
              />
              数据加载中...
            </div>
            <div class="empty-box" v-if="!isLoading && !customers.length">
              列表为空
            </div>
          </template>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndex"
          :page-sizes="[20, 50, 100]"
          :page-size="query.maxResultCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import indexJs from "./index.js";
export default {
  ...indexJs,
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>